<template>
  <footer
    :class="s.footer"
    :style="style">
    <ul :class="s.icons">
      <li
        v-for="item in menuItems"
        :key="item.name"
        :class="isActive === item.name ? s.isActive : ''">
        <router-link :to="item.path">
          <i :class="item.icon"/>
          <div
            v-if="badgeCount(item)"
            :class="s.badge">{{ badgeCount(item) }}</div>
        </router-link>
      </li>
    </ul>
  </footer>
</template>

<script>
import { mapState } from 'vuex';
import cf from '@/mixins/commonFunctions';

export default {
  name: 'GlobalFooter',
  mixins: [cf],
  components: {
  },
  data() {
    return {
      menuItems: cf.getMenuItems(),
      count: null,
    };
  },
  computed: {
    ...mapState(['user']),
    style() {
      return {
        '--footer-item-num': cf.getMenuItems().length,
      };
    },
    isActive() {
      const page = cf.getPage(this.$route.path);
      return page.name;
    },
  },
  created() {
    this.getBadgeCount();
  },
  watch: {
    user: {
      handler() {
        this.getBadgeCount();
      },
      deep: true,
    },
  },
  methods: {
    getBadgeCount() {
      const params = {
        user_id: this.user.id,
      };
      this.axios({
        method: 'GET',
        url: '/v1/driver/get/notificationCount',
        params,
      })
        .then((response) => {
          const res = response.data;
          if (res.count) this.count = res.count;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          console.log(error);
        });
    },
    badgeCount(item) {
      if (!item?.name || !this.count) return null;
      return this.count[item.name] || null;
    },
  },
};
</script>

<style lang="scss" module="s">
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 5;
  width: 100%;
  height: var(--footer-height);
  background-color: #ffffff;
  border-top: 1px solid var(--border-gray);

  .icons {
    width: 100%;
    height: 100%;
    display: flex;
    > li {
      position: relative;
      width: calc(100% / var(--footer-item-num));
      > a {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        width: 100%;
        height: 100%;
      }

      &.isActive {
        > a {
          color: var(--thema-color);
        }
      }

      .badge {
        padding: 4px 10px;
        border-radius: 12px;
        background-color: var(--primary-red);
        color: #ffffff;
        font-weight: bold;
        font-size: 10px;
        position: absolute;
        top: 50%; left: 50%;
        transform: translate(4px, -25px);
      }
    }
  }
}
</style>
